import React from 'react'

import {
  Check, Divider, Icon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, node, oneOf, string,
} from 'prop-types'

import { TIER } from 'Pods/Profile/Settings/SubscriptionManagement/constants'
import TierMark from 'Pods/Profile/Settings/SubscriptionManagement/Shared/TierMark/TierMark'

const CHECK_SIZE = { width: '16', height: '16' }

function TierCard({
  tier,
  name,
  price,
  priceTerm = null,
  priceNote = null,
  features,
  badge = null,
  divider = false,
  children = null,
}) {
  return (
    <div className="tier-card">
      <div className="tier-card__header">
        <div className="tier-card__name">
          <TierMark tier={tier} />
          <h4 className="cgt-heading-100">{name}</h4>
        </div>
        {badge}
      </div>
      <div>
        <p className="tier-card__price">
          <span className="cgt-heading-400">{price}</span>
          {priceTerm && <span className="cgt-body-base tier-card__price-term">{priceTerm}</span>}
        </p>
        {priceNote && <p className="cgt-caption tier-card__price-note">{priceNote}</p>}
      </div>
      {divider && <Divider customClass="tier-card__divider" />}
      <ul className="tier-card__features">
        {features.map((feature) => (
          <li key={feature} className="tier-card__feature cgt-body-base">
            <Icon
              svgComponent={Check}
              color={tier === TIER.PREMIUM ? undefined : 'primary'}
              size={CHECK_SIZE}
              className={classnames('tier-card__check', `tier-card__check--${tier}`)}
              notSpaced
            />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      {children}
    </div>
  )
}

TierCard.propTypes = {
  tier: oneOf([TIER.ESSENTIALS, TIER.PREMIUM]).isRequired,
  name: string.isRequired,
  price: string.isRequired,
  priceTerm: string,
  priceNote: string,
  features: arrayOf(string).isRequired,
  badge: node,
  divider: bool,
  children: node,
}

export default TierCard
